function loadGtm() {
  const id = document.querySelector('meta[name="gtm-id"]')?.content;
  if (!id || window.gtmLoaded) return;
  window.gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);
}
loadGtm();
